import { React } from "react";
function Course()
{
    return(
        <div><center><h1>This is Contact Component</h1></center>
        <hr/>
        </div>
    )
}
export default Course;